import React from 'react';
import { Card } from '@frontend/shadcn/components/ui/card';
import { HoverCard, HoverCardContent, HoverCardTrigger } from '@frontend/shadcn/components/ui/hover-card';
import { CircleInfoIcon } from '@revfluence/fresh-icons/regular/esm';
import { cn } from '@frontend/shadcn/lib/utils';

interface ProjectWidgetContainerProps {
  children: React.ReactNode;
  title: string;
  icon: React.ReactNode;
  tooltip?: string;
  className?: string;
}

export const ProjectWidgetContainer = (props: ProjectWidgetContainerProps) => {
  const { children, title, icon, tooltip, className } = props;

  return (
    <Card
      className={cn(
        'w-80 pb-4 inline-flex flex-col justify-start items-start overflow-hidden',
        className,
      )}
    >
      {/* Header Section */}
      <div className="self-stretch px-4 py-3 flex flex-col justify-center items-start gap-6">
        <div className="self-stretch inline-flex justify-start items-center gap-2">
          <div className="flex-1 rounded-md flex justify-start items-center gap-2">
            {/* Icon */}
            <div className="h-4 flex justify-center items-center text-gray-400 text-base">{icon}</div>

            {/* Title */}
            <div className="justify-start text-gray-800 text-sm font-medium font-['Inter'] leading-normal">{title}</div>

            {/* Tooltip Icon */}
            {tooltip && (
              <HoverCard>
                <HoverCardTrigger asChild>
                  <div className="h-3 relative flex justify-center items-center cursor-help">
                    <CircleInfoIcon className="w-3 h-3 text-gray-400 cursor-pointer" />
                  </div>
                </HoverCardTrigger>
                <HoverCardContent className="w-64">{tooltip}</HoverCardContent>
              </HoverCard>
            )}
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="self-stretch px-4 flex flex-col justify-start items-start h-full">{children}</div>
    </Card>
  );
};
